import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ClienteCentralCompra } from '../cliente-central-compra';

@Component({
    selector: 'sgt-cliente-central-compra-form-control-text',
    templateUrl: './cliente-central-compra-form-control-text.component.html',
    styleUrls: ['./cliente-central-compra-form-control-text.component.less']
})
export class ClienteCentralCompraFormControlTextComponent {
    @Input() id: number;
    @Input() nomeFantasia: string;
    @Input() nome: string;
    @Input() helpText: string = null;
    @Input() isShowBtnOpen = true;
    @Output() openCentralCompra = new EventEmitter<number>();
}
